export const europeanCities = {
  // Hrvatska
  'Hrvatska': [
    'Zagreb', 'Split', 'Rijeka', 'Osijek', 'Zadar', 'Pula', 'Slavonski Brod',
    'Karlovac', 'Varaždin', 'Šibenik', 'Sisak', 'Dubrovnik', 'Velika Gorica',
    'Bjelovar', 'Vinkovci', 'Čakovec', 'Vukovar', 'Koprivnica', 'Samobor'
  ],
  
  // Srbija
  'Srbija': [
    'Beograd', 'Novi Sad', 'Niš', 'Kragujevac', 'Subotica', 'Zrenjanin',
    'Pančevo', 'Čačak', 'Kraljevo', 'Smederevo', 'Leskovac'
  ],
  
  // Bosna i Hercegovina
  'Bosna i Hercegovina': [
    'Sarajevo', 'Banja Luka', 'Tuzla', 'Zenica', 'Mostar', 'Bijeljina',
    'Brčko', 'Prijedor', 'Trebinje', 'Cazin'
  ],
  
  // Slovenija
  'Slovenija': [
    'Ljubljana', 'Maribor', 'Celje', 'Kranj', 'Velenje', 'Koper',
    'Novo Mesto', 'Ptuj', 'Kamnik', 'Nova Gorica'
  ],
  
  // Italija
  'Italija': [
    'Rim', 'Milano', 'Napulj', 'Torino', 'Palermo', 'Genova', 'Bologna',
    'Firenza', 'Bari', 'Catania', 'Verona', 'Venecija', 'Messina', 'Padova',
    'Trst', 'Brescia', 'Parma', 'Prato', 'Modena', 'Reggio Calabria'
  ],
  
  // Austrija
  'Austrija': [
    'Beč', 'Graz', 'Linz', 'Salzburg', 'Innsbruck', 'Klagenfurt',
    'Villach', 'Wels', 'Sankt Pölten', 'Dornbirn'
  ],
  
  // Mađarska
  'Mađarska': [
    'Budimpešta', 'Debrecen', 'Szeged', 'Miskolc', 'Pécs', 'Győr',
    'Nyíregyháza', 'Kecskemét', 'Székesfehérvár', 'Szombathely'
  ],
  
  // Njemačka
  'Njemačka': [
    'Berlin', 'Hamburg', 'München', 'Köln', 'Frankfurt', 'Stuttgart',
    'Düsseldorf', 'Dortmund', 'Essen', 'Leipzig', 'Bremen', 'Dresden',
    'Hannover', 'Nürnberg', 'Duisburg', 'Bochum', 'Wuppertal', 'Bielefeld'
  ],
  
  // Francuska
  'Francuska': [
    'Pariz', 'Marseille', 'Lyon', 'Toulouse', 'Nice', 'Nantes',
    'Strasbourg', 'Montpellier', 'Bordeaux', 'Lille', 'Rennes',
    'Reims', 'Le Havre', 'Saint-Étienne', 'Toulon', 'Grenoble'
  ],
  
  // Španjolska
  'Španjolska': [
    'Madrid', 'Barcelona', 'Valencia', 'Sevilla', 'Zaragoza', 'Málaga',
    'Murcia', 'Palma', 'Las Palmas', 'Bilbao', 'Alicante', 'Córdoba',
    'Valladolid', 'Vigo', 'Gijón', 'Granada'
  ],
  
  // Velika Britanija
  'Velika Britanija': [
    'London', 'Birmingham', 'Manchester', 'Glasgow', 'Liverpool',
    'Edinburgh', 'Leeds', 'Bristol', 'Sheffield', 'Newcastle',
    'Belfast', 'Cardiff', 'Nottingham', 'Leicester', 'Southampton'
  ],
  
  // Nizozemska
  'Nizozemska': [
    'Amsterdam', 'Rotterdam', 'Haag', 'Utrecht', 'Eindhoven',
    'Tilburg', 'Groningen', 'Almere', 'Breda', 'Nijmegen'
  ],
  
  // Belgija
  'Belgija': [
    'Bruxelles', 'Antwerpen', 'Gent', 'Charleroi', 'Liège',
    'Brugge', 'Namur', 'Leuven', 'Mons', 'Aalst'
  ],
  
  // Švicarska
  'Švicarska': [
    'Zürich', 'Ženeva', 'Basel', 'Lausanne', 'Bern', 'Winterthur',
    'Luzern', 'St. Gallen', 'Lugano', 'Biel'
  ],
  
  // Poljska
  'Poljska': [
    'Varšava', 'Krakov', 'Łódź', 'Wrocław', 'Poznań', 'Gdańsk',
    'Szczecin', 'Bydgoszcz', 'Lublin', 'Katowice'
  ],
  
  // Češka
  'Češka': [
    'Prag', 'Brno', 'Ostrava', 'Plzeň', 'Liberec', 'Olomouc',
    'České Budějovice', 'Hradec Králové', 'Ústí nad Labem', 'Pardubice'
  ],
  
  // Slovačka
  'Slovačka': [
    'Bratislava', 'Košice', 'Prešov', 'Žilina', 'Banská Bystrica',
    'Nitra', 'Trnava', 'Martin', 'Trenčín', 'Poprad'
  ],
  
  // Rumunjska
  'Rumunjska': [
    'Bukurešt', 'Cluj-Napoca', 'Timișoara', 'Iași', 'Constanța',
    'Craiova', 'Brașov', 'Galați', 'Ploiești', 'Oradea'
  ],
  
  // Bugarska
  'Bugarska': [
    'Sofija', 'Plovdiv', 'Varna', 'Burgas', 'Ruse', 'Stara Zagora',
    'Pleven', 'Sliven', 'Dobrich', 'Shumen'
  ],
  
  // Grčka
  'Grčka': [
    'Atena', 'Solun', 'Patras', 'Heraklion', 'Larisa', 'Volos',
    'Ioannina', 'Chania', 'Chalcis', 'Serres'
  ],
  
  // Portugal
  'Portugal': [
    'Lisabon', 'Porto', 'Amadora', 'Braga', 'Setúbal', 'Coimbra',
    'Queluz', 'Funchal', 'Cacém', 'Vila Nova de Gaia'
  ],
  
  // Švedska
  'Švedska': [
    'Stockholm', 'Göteborg', 'Malmö', 'Uppsala', 'Västerås',
    'Örebro', 'Linköping', 'Helsingborg', 'Jönköping', 'Norrköping'
  ],
  
  // Norveška
  'Norveška': [
    'Oslo', 'Bergen', 'Trondheim', 'Stavanger', 'Drammen',
    'Fredrikstad', 'Kristiansand', 'Sandnes', 'Tromsø', 'Sarpsborg'
  ],
  
  // Finska
  'Finska': [
    'Helsinki', 'Espoo', 'Tampere', 'Vantaa', 'Oulu', 'Turku',
    'Jyväskylä', 'Lahti', 'Kuopio', 'Pori'
  ],
  
  // Danska
  'Danska': [
    'Kopenhagen', 'Århus', 'Odense', 'Aalborg', 'Esbjerg',
    'Randers', 'Kolding', 'Horsens', 'Vejle', 'Roskilde'
  ],
  
  // Irska
  'Irska': [
    'Dublin', 'Cork', 'Limerick', 'Galway', 'Waterford',
    'Drogheda', 'Dundalk', 'Swords', 'Bray', 'Navan'
  ]
};

// Funkcija za dohvat svih gradova
export const getAllCities = () => {
  const cities = [];
  Object.keys(europeanCities).forEach(country => {
    europeanCities[country].forEach(city => {
      cities.push({ city, country });
    });
  });
   const customCities = JSON.parse(localStorage.getItem('customCities') || '[]');
  cities.push(...customCities);
  return cities.sort((a, b) => a.city.localeCompare(b.city, 'hr'));
};

// Funkcija za pretragu gradova
export const searchCities = (query) => {
  const allCities = getAllCities();
  return allCities.filter(item => 
    item.city.toLowerCase().includes(query.toLowerCase()) ||
    item.country.toLowerCase().includes(query.toLowerCase())
  );
};
export const addCustomCity = (cityName, countryName) => {
  const customCities = JSON.parse(localStorage.getItem('customCities') || '[]');
  
  const newCity = {
    city: cityName,
    country: countryName,
    custom: true,
    addedAt: new Date().toISOString()
  };
  
  customCities.push(newCity);
  localStorage.setItem('customCities', JSON.stringify(customCities));
  
  return newCity;
};
